import React, { useMemo } from "react";

import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Message from "shared/components/Message";
import OpeningHours from "shared/components/OpeningHours";
import Popover from "shared/components/Popover";
import Space from "shared/components/Space";
import { NAME_SPACES } from "shared/locals/constants";
import { formatOpeninHours } from "utils/helpers/hours";
import { useInfo } from "utils/hooks/info";

const Component = ({ values, error }) => {
  const {
    info,
    commonInfo: { knownCustomer },
  } = useInfo();
  const { t } = useTranslation(NAME_SPACES.ACCOUNT);
  const LABELS = t("WARNINGS", { returnObjects: true });
  const openingHours = useMemo(
    () => formatOpeninHours(info.openHours),
    [info.openHours],
  );

  return (
    <>
      <Message
        level={"warning"}
        message={LABELS.MESSAGE}
        visible={
          values.geolocalized && (!values.address1 || error?.statusCode === 472)
        }
      />
      <Message
        level={"warning"}
        message={
          <>
            {t("WARNINGS.GEOLOCALIZED", {
              phone: info.phone,
            })}
            <Popover content={<OpeningHours data={openingHours} />}>
              <b>{t("WARNINGS.WARNING_OPENINGHOURS")}</b>
            </Popover>
          </>
        }
        visible={!values.geolocalized && knownCustomer}
      />
      {(!values.geolocalized ||
        !values.address1 ||
        error?.statusCode === 472) && <Space h={24} />}
    </>
  );
};

Component.propTypes = {
  values: PropTypes.shape({
    address1: PropTypes.string.isRequired,
    geolocalized: PropTypes.bool.isRequired,
  }).isRequired,
  error: PropTypes.shape({
    statusCode: PropTypes.number.isRequired,
  }),
};

Component.defaultProps = {};

export default Component;
